import { render, staticRenderFns } from "./LandParcelSegments.vue?vue&type=template&id=2c9e8e1c&scoped=true&"
import script from "./LandParcelSegments.vue?vue&type=script&lang=js&"
export * from "./LandParcelSegments.vue?vue&type=script&lang=js&"
import style0 from "./LandParcelSegments.vue?vue&type=style&index=0&id=2c9e8e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9e8e1c",
  null
  
)

export default component.exports